import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ContextHeadline } from '@aok/text-elements'
import { PrimaryButton } from '@aok/ui-elements'
import Icon from '@aok/icon-linear'

import { getHeadlineText } from '../../../utils/TextUtils'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { HeadlineTag } from '../../../utils/constants/typography'

const CtaModule = ({ headline, text, link, icon, settings, className, innerClassName }) => {
  const headlineSizeClasses = classNames({
    'text-36 leading-44 480:text-40 480:leading-48 1280:text-48 1280:leading-60':
      settings?.headlineSize === HeadlineTag.H2,
    'text-28 leading-36 1280:text-32 1280:leading-44': settings?.headlineSize === HeadlineTag.H3,
  })

  return (
    <div className={`${className}`}>
      <div className={`${innerClassName}`}>
        {icon && (
          <div className="flex justify-center items-center mb-24">
            <Icon name={icon} className="w-40 h-40 fill-005e3f" />
          </div>
        )}

        <ContextHeadline
          text={getHeadlineText(headline, 'text-18ab42')}
          className={`text-005e3f text-center font-semibold font-buenos-aires ${headlineSizeClasses}`}
        />
        <p className="text-16 leading-24 text-293033 text-center mt-24">{text}</p>
        <div className="flex flex-col justify-center items-center mt-40">
          <PrimaryButton url={link?.url} target={link?.target}>
            {link?.title}
          </PrimaryButton>
        </div>
      </div>
    </div>
  )
}

CtaModule.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  text: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self']),
  }),
  settings: PropTypes.shape({
    headlineSize: PropTypes.oneOf([HeadlineTag.H2, HeadlineTag.H3]),
  }),
  className: PropTypes.string,
  innerClassName: PropTypes.string,
}

CtaModule.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  text: defaultProps.TEXT,
  link: {
    title: defaultProps.TITLE,
    url: defaultProps.URL,
    target: '_self',
  },
  settings: {
    headlineSize: HeadlineTag.H3,
  },
  className: '',
  innerClassName: '',
}

export default CtaModule
